import {AccountBasicFragment_contacts} from '../../schema-types/AccountBasicFragment';

/**
 * OneView should display only Contact, Dependant and Prospect.
 * This list of statuses is exhaustive as per Jess
 * @param accountId
 * @param contacts
 * @returns sorted valid contacts
 */
export function sortAccountContacts<
  C extends {
    contactStatus: AccountBasicFragment_contacts['contactStatus'];
    accountContacts: AccountBasicFragment_contacts['accountContacts'];
    [key: string]: any;
  }
>(accountId: string | null, contacts: C[]): C[] {
  let payload: C[] = [];
  if (!accountId) {
    return payload;
  }
  // there can only be one primary contact
  const primaryContact = contacts.find((contact) => {
    return (
      (contact.contactStatus === 'Client' || contact.contactStatus === 'Prospect') &&
      contact.accountContacts.some(
        (accountContact) =>
          accountContact.account.id === accountId &&
          accountContact.isPrimary !== null &&
          accountContact.isPrimary
      )
    );
  });
  if (primaryContact) {
    payload.push(primaryContact);
  }
  // there can be 0,1 or more secondary contacts
  const secondaryContacts = contacts.filter((contact) => {
    return (
      (contact.contactStatus === 'Client' || contact.contactStatus === 'Prospect') &&
      contact.accountContacts.some(
        (accountContact) =>
          accountContact.account.id === accountId &&
          accountContact.isSecondary !== null &&
          accountContact.isSecondary
      )
    );
  });
  payload = [...payload, ...secondaryContacts];
  // there can be 0,1 or more dependant contacts
  const dependantContacts = contacts.filter((contact) => {
    return (
      contact.contactStatus === 'Dependant' &&
      contact.accountContacts.some(
        (accountContact) => accountContact.account.id === accountId
      )
    );
  });
  payload = [...payload, ...dependantContacts];

  return payload;
}
